<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="pl-4 pr-4" [formGroup]="form1">
  <p-fieldset styleClass="p-fluid " legend="Select Property" [toggleable]="true" [collapsed]="false">
    <div class="p-formgrid grid">
      <div class="col-12">
        <b>Select Property</b>
      </div>
      <div class="p-field col-12 mt-3">
        <span class="p-float-label">
          <p-dropdown
            [options]="shortTermRentals"
            formControlName="shortTermRentalId"
            optionLabel="propertyCode"
            optionValue="shortTermRentalId"
            [filter]="true"
            filterBy="propertyCode"
            [showClear]="false"
            placeholder="Select Property">
          </p-dropdown>
          <label for="shortTermRentalId">Select Property</label>
          @for (validation of validationMessages.shortTermRentalId; track validation) {
            <span>
              @if (form1.get('shortTermRentalId')?.hasError(validation.type) && (form1.get('shortTermRentalId')?.dirty || form1.get('shortTermRentalId')?.touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <p-divider class="col-12 mt-3 mb-3"></p-divider>

      <div class="col-12 mb-2">
        <b>Sync Availability</b>
      </div>
      <div class="p-field col-12 md:col-4">
        <button pButton class="p-button" type="button" style="width:260px;" label="Sync Unit Availability" (click)="onSyncUnitAvailability()"></button>
      </div>

      @if (form1.value.shortTermRentalId) {
        <div class="p-field col-12 md:col-4">
          <a target="_blank" [routerLink]="['/logmans/short-term-rental', 'createUnitAvailabilityUpdate', form1.value.shortTermRentalId]">
            View Logman (Unit Availability) for #{{form1.value.shortTermRentalId}}
          </a>
        </div>
      }
    </div>
  </p-fieldset>
</div>


